import React, { useCallback } from 'react';
import { useApiGet } from 'hooks/useApi';
import Pagination from 'models/Pagination';
import apiPaths from 'constants/apiPaths';
import { ExternalNews } from 'models/ExternalNews';

const useControllerInternalsNewsListDragPage = () => {
  const [filteredData, setFilteredData] = React.useState({
    pageSize: 10,
    page: 1,
    search: ''
  });

  const { data: externalNews, isLoading } = useApiGet<Pagination<ExternalNews>>(
    apiPaths.externalNews,
    {
      params: filteredData
    }
  );

  const handleSearch = useCallback(
    (search: string) => {
      setFilteredData({ ...filteredData, search });
    },
    [filteredData]
  );
  const handlePageChange = useCallback(
    (page: number) => {
      setFilteredData({ ...filteredData, page });
    },
    [filteredData]
  );

  return {
    filteredData,
    setFilteredData,
    externalNews,
    isLoading,
    handleSearch,
    handlePageChange
  };
};

export default useControllerInternalsNewsListDragPage;
